import React, {useState} from "react";

import InterviewerList from "components/InterviewerList";
import Button from "components/Button";


export default function Form(props) {
  const [error, setError] = useState("");
  const reset = ()=> {
    setStudent("");
    setInterviewer(null);
  }

  const cancel = ()=>{
    setError("")
    reset();
    //why use function here
    props.onCancel();
  }


  function validate() {
    if (student === "") {
      setError("student name cannot be blank");
      return;
    }

    if (interviewer === null) {
      setError("please select an interviewer");
      return;
    }
    setError("")
    props.onSave(student, interviewer);
  }

  
  const [student, setStudent] = useState(props.student || "");
  const [interviewer, setInterviewer] = useState(props.interviewer || null);
  return (
  <main className="appointment__card appointment__card--create">
    <section className="appointment__card-left">
      <form autoComplete="off" onSubmit={event => event.preventDefault()}>
        <input 
          className="appointment__create-input text--semi-bold"
          name="name"
          type="text"
          placeholder="Enter Student Name"
          value={student}
          onChange={(event) => {setStudent(event.target.value)}}
          data-testid="student-name-input"
        />
      </form>
      <section className="appointment__validation">{error}</section>
      <InterviewerList
        interviewers={props.interviewers}
        // unsure here
        value={interviewer}
        onChange={setInterviewer}
      />
    </section>
    <section className="appointment__card-right"> 
      <section className="appointment__actions">
        <Button danger onClick={cancel}>Cancel</Button>
        <Button confirm onClick={()=> validate()}>Save</Button>
      </section>
    </section>
  </main>)
}